import { NotepadText } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function SummarizationHeader() {
  const { t } = useTranslation()

  return (
    <header className='flex justify-between items-center border-b pb-4 mb-8'>
      <div className='flex items-center space-x-3'>
        <div className='flex items-center justify-center h-10 w-10 rounded-lg bg-white border border-gray-200 shadow-sm'>
          <NotepadText className='h-6 w-6 text-gray-800' />
        </div>
        <div>
          <h1 className='text-xl font-bold text-gray-800'>
            {t('summarization.title')}
          </h1>
          <p className='text-sm text-gray-500'>
            {t('summarization.description')}
          </p>
        </div>
      </div>
    </header>
  )
}
